import { render, staticRenderFns } from "./SearchMusicTagsFilter.vue?vue&type=template&id=1eda0c47&scoped=true"
import script from "./SearchMusicTagsFilter.vue?vue&type=script&lang=js"
export * from "./SearchMusicTagsFilter.vue?vue&type=script&lang=js"
import style0 from "./SearchMusicTagsFilter.vue?vue&type=style&index=0&id=1eda0c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda0c47",
  null
  
)

export default component.exports